module.exports = __webpack_public_path__ + "img/creative.e158b76.webp";